<template>
    <div
            id="property-map"
            ref="map"
            :class="{ processing: processing }"
    >
        <i class="far fa-compass fa-spin"></i>
    </div>
</template>
<script>
    import MapStyle from './Styles/HideIcons';
    import { Loader as GoogleMapsLoader } from 'google-maps';
    import Processor from '../../mixins/Processing';

    export default {
        mixins: [Processor],
        props: {
            center: {
                type: Object,
                default: () => {
                    return {
                        lat: 50.934377,
                        lng: -0.271384,
                    };
                },
            },
            locations: {
                type: Array,
                default: () => [{ lat: 50.930015, lng: -0.271062 }],
            },
            infoWindowTemplate: {
                type: Function,
                required: false,
                default: (location) => {
                    return '<div class="poi-info-window gm-style"><div><div class="title full-width">The Henfield Hall</div><div class="address"><div class="address-line full-width">Coopers Way</div><div class="address-line full-width">Henfield</div><div class="address-line full-width">BN5 9DB</div></div></div><div class="view-link"> <a target="_blank" href="https://maps.google.com/maps?ll=50.930015,-0.271062&amp;z=19&amp;t=m&amp;hl=en-GB&amp;gl=GB&amp;mapclient=apiv3&amp;cid=1932527580477771825"> <span>View on Google Maps</span> </a> </div> </div>';
                },
            },
        },
        data() {
            return {
                map: null,
                google: null,
                bounds: null,
                zoom: 15,
                fields: {
                    address: '',
                    location: '',
                    travelMode: 'DRIVING',
                },
                markers: [],
                infoWindow: null,
            };
        },
        created() {
            this.startCall();
        },
        mounted() {
            setTimeout(this.initialize, 500);
        },
        methods: {
            initialize() {
                const key = document.head.querySelector('meta[name="google-api-key"]');

                if (this.locations.length === 0 || !key) {
                    this.endCall();
                    return;
                }

                const loader = new GoogleMapsLoader(key.content, {
                  version: 'weekly',
                  libraries: ['places'],
                  language: 'gb',
                  region: 'GB',
                });

                loader.load().then(google => {
                    this.google = google;

                    this.bounds = new this.google.maps.LatLngBounds;

                    this.map = new this.google.maps.Map(this.$refs.map, {
                        center: this.center,
                        zoom: this.zoom,
                        mapTypeControl: this.mapTypeControl,
                        mapTypeControlOptions: {
                            style: this.google.maps.MapTypeControlStyle.DEFAULT,
                            position: this.google.maps.ControlPosition.LEFT_TOP,
                        },
                        styles: MapStyle,
                        fullscreenControl: true,
                        fullscreenControlOptions: {
                            position: this.google.maps.ControlPosition.RIGHT_TOP,
                        },
                    });

                    this.addMarkers();
                    this.endCall();
                });
            },
            addMarkers() {
                this.locations.forEach(location => {
                    this.addMarker(location);
                });
            },
            addMarker(location) {

                if (!Object.keys(location).length) {
                    return;
                }

                let lat = location.lat || (location.location ? location.location.lat : 0),
                    lng = location.lng || (location.location ? location.location.lng : 0);

                if (!lat && !lng) {
                    return;
                }

                let marker = new this.google.maps.Marker(Object.assign({
                    map: this.map,
                    position: { lat: lat, lng: lng },
                    animation: this.google.maps.Animation.DROP,
                    draggable: false,
                }, location.icon ? { icon: location.icon } : {}));

                this.markers.push(marker);

                this.attachInfoWindow(marker, location);
                this.updateMapLayout(marker);
            },
            attachInfoWindow(marker, location) {
                if (!this.infoWindowTemplate) {
                    return;
                }
                let infoWindow = new google.maps.InfoWindow({
                    content: this.infoWindowTemplate(location),
                });
                infoWindow.open(this.map, marker);
                marker.addListener('click', () => {
                    if (this.infoWindow) {
                        this.infoWindow.close();
                    }
                    (this.infoWindow = infoWindow).open(this.map, marker);
                });
            },
            updateMapLayout(marker) {
                let listener = this.google.maps.event.addListener(
                    this.map,
                    'zoom_changed',
                    () => {
                        if (this.markers.length < 2 && this.map.getZoom() > this.zoom) {
                            this.map.setZoom(this.zoom);
                        }
                        this.google.maps.event.removeListener(listener);
                    },
                );

                let latLng = new google.maps.LatLng(
                    marker.position.lat(),
                    marker.position.lng(),
                );
                this.bounds.extend(latLng);
                this.map.fitBounds(this.bounds);
                this.map.panToBounds(this.bounds);
            },
        },
    };
</script>
